export default __webpack_public_path__ + "static/media/github.7796e564.webp";